import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class StdSubjectDomainService {
  static async getTreeList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdSubjectDomain/get_tree_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async queryTreeList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdSubjectDomain/query_tree_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async detail(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdSubjectDomain?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async save(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdSubjectDomain', payload))
    return Callback(err, res)
  }
  static async update(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdSubjectDomain', payload))
    return Callback(err, res)
  }
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdSubjectDomain', payload))
    return Callback(err, res)
  }
  static async getRelationClassList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdSubjectDomain/get_relation_class_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async saveRelation(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdSubjectDomain/save_relation', payload)
    )
    return Callback(err, res)
  }
  static async removeSubjectDomainRelation(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdClassSubjectDomainRelation', payload)
    )
    return Callback(err, res)
  }
  static async getSelectRelationClassList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdSubjectDomain/get_select_relation_class_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async list(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdSubjectDomain/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取主题树
  static async getSubjectDomainTree(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdSubjectDomain/tree?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
